import Submissions from './submissions'

export default {
  Submissions,
}
